<div class="track-list-wrapper" #trackListWrapper>
	<div 
		class="item-list"
		cdkDropList 
		id="tracksList"
		#tracksList
		[cdkDropListData]="flatArray"
		[cdkDropListConnectedTo]="allDropLists"
		(cdkDropListDropped)="onItemDropped($event)"
		[cdkDropListDisabled]="hiddenTracks?.length > 0">
		<div 
			*ngIf="chapterConfig?.timepoints?.data?.length > 0" 
			class="timepoint-track-container">
			<timepoint-track 
				[timepointConfig]="chapterConfig" 
				[theme]="'chapter-theme'"
				[tooltip]="'left'" 
				[dragger]="'chapter'" 
				(onDragging)="timepointDragging = $event"
				[class.add-chapter]="showGhost && widgetType === 'chapter'">
			</timepoint-track>
		</div>
		<div 
			*ngIf="widgetType === 'chapter' && !chapterConfig?.timepoints?.data?.length" 
			class="track-container ghost-track"
			[hidden]="!showGhost">
			<ng-container *ngTemplateOutlet="ghostTrack"></ng-container>
		</div>
	
		<ng-container *ngFor="let item of flatArray; let i=index; trackBy: trackBy">
			<div 
				#track 
				[hidden]="hiddenTracks.indexOf(item.id) !== -1"
				[style.opacity]="(selectedTracks?.length > 1 && selectedTrackIds?.indexOf(item.id) > -1 && draggingTrack) ? 0.2 : 1"
				class="track-container" 
				cdkDrag 
				cdkDragLockAxis="y" 
				[cdkDragDisabled]="editMode || !item?.child || item?.type === 'trackFromApp'" 
				[id]="item?.id"
				(cdkDragStarted)="onTrackDragStart(item.child, $event)"
				(cdkDragEnded)="onTrackDragEnd(item.child, $event)"
				cdkDragBoundary=".item-list"
				>
					<track
						(onEditTrack)="editTrack($event)"
						(mousedown)="onTrackMousedown(item, $event)"
						(contextmenu)="onTrackContextMenu($event, item)"
						(trackElementContextMenu)="onTrackElementContextMenu($event?.ev, $event?.item)"
						class="item"
						[track]="item?.child"
						[tracks]="filterCurrentTrack(flatArray, item?.child)"
						[type]="item?.type"
						[index]="i"
						[selectedTrackIds]="selectedTrackIds"
						*ngIf="item?.child"
						[hiddenTracks]="hiddenTracks"
						[ngClass]="{'time-based-timeline': interactivityEditorService.parentEntityType !== 'App'}"
						>
					<div *ngIf="!item.child" class="group-end"></div>
				<!-- <ng-container *ngIf="selectedTracks?.length > 1"> -->
					<div *cdkDragPreview class="track-container">
						<ng-container *ngFor="let selectedTrack of selectedTracks; let j=index; trackBy: trackBy">
							<track 
								class="item" 
								*ngIf="selectedTrack?.child"
								[track]="selectedTrack?.child"
								[tracks]="filterCurrentTrack(flatArray, selectedTrack?.child)"
								[type]="selectedTrack?.type"
								[selectedTrackIds]="selectedTrackIds"
								[index]="j"
								>
							<div *ngIf="selectedTrack.type === 'trackGroupEnd'" class="group-end"></div>
						</ng-container>
					</div>
				<!-- </ng-container> -->
			</div>
			<div class="ghost-track" [hidden]="!showGhost || i !== ghostTrackIndex || widgetType ==='chapter'">
				<ng-container *ngTemplateOutlet="ghostTrack"></ng-container>
			</div>
		</ng-container>
		<div *ngIf="widgetType && !flatArray.length && widgetType !== 'chapter'" class="track-container ghost-track" [hidden]="!showGhost">
			<ng-container *ngTemplateOutlet="ghostTrack"></ng-container>
		</div>
	</div>
	<bb-resizable-scrollbar #verticalScrollbar [orientation]="'vertical'" [scrollElement]="tracksList" [useResize]="false"></bb-resizable-scrollbar>
</div>
<div class="filter-bar">
	<div class="free-text-filter">
		<input type="text" [(ngModel)]="freeTextFilter" (input)="onFilterInput($event, filterInput)" #filterInput [placeholder]="('FILTER' | translate) + '...'" />
		<i class="i fa fa-search"></i>
	</div>
	<div class="filters-wrapper">
		<bb-scrollable-pane class="scroll-bar" #scrollablePane>
			<div
				[hidden]="filterableWidgetTypes?.length === 1"
				*ngFor="let widgetType of filterableWidgetTypes"
				class="widget-type-button" (click)="toggleWidgetTypeFilter(widgetType)"
				[class.active]="activeWidgetTypeFilters.indexOf(widgetType) !== -1"
			>
				<span class="icon" [innerHTML]="widgetType | widgetIcon"></span>
			</div>
			<div
				[hidden]="widgetGroupTags?.length === 1"
				*ngFor="let widgetGroupTag of widgetGroupTags"
				class="widget-group-tag-button" (click)="toggleWidgetGroupTag(widgetGroupTag)"
				[class.active]="activeWidgetGroupIDs.indexOf(widgetGroupTag.id) !== -1"
			>
				<span class="text">#{{ widgetGroupTag.label }}</span>
			</div>
			<div class="clear-filters" (click)="clearFilters()" [hidden]="!freeTextFilter && activeWidgetTypeFilters?.length === 0 && activeWidgetGroupIDs?.length === 0">
				<i class="i fa fa-times-circle"></i>
				{{ 'CLEAR' | translate | lowercase }}
			</div>
		</bb-scrollable-pane>
	</div>
	
	<div class="zoom-bar" *ngIf="interactivityEditorService.parentEntityType === 'MediaClip'">
		<div class="ie-icon-button" [class.disabled]="trackZoomInfo?.zoomFactor === 1" (click)="zoom('out')" [title]="'ZOOM_OUT' | translate">-</div>
		<div class="zoom-icon ie-icon-display" [class.disabled]="trackZoomInfo?.zoomFactor === 1" (click)="zoom('toFit')" [title]="'ZOOM_TO_FIT' | translate">
			<i class="fa fa-search"></i>
		</div>
		<div class="ie-icon-button" (click)="zoom('in')" [title]="'ZOOM_IN' | translate">+</div>
	</div>
</div>
<bb-context-menu [ngStyle]="contextMenuStyle" [themeName]="'dark-theme'" [options]="contextMenuOptions" (optionSelected)="onContextMenuOptionSelected($event)" (clickOutside)="contextMenuHide()"></bb-context-menu>

<ng-template #ghostTrack>
	<div class="ghost-track-label">
		<div class="ghost-icon"><span [innerHTML]="widgetType | widgetIcon"></span></div>
		<span [innerHTML]="'ADD_NONVISUAL_WIDGET' | translate: {widgetType: 'WIDGET_TYPE_' + widgetType | uppercase | translate}"></span>
	</div>
</ng-template>